import swIcon1 from '../images/service/icon-1.png'
import swIcon2 from '../images/service/icon-2.png'
import swIcon3 from '../images/service/icon-3.png'
import swIcon4 from '../images/service/icon-4.png'
import swIcon5 from '../images/service/icon-5.png'



const Services = [
    {
        Id: '1',
        sIcon:swIcon1,
        title: 'Web UI/UX Design',
        slug: 'Web-UI-UX-Design',
        description:'We are helping client to create WordPress websites.',
        des2:'We are helping client to create WordPress websites.We are helping client to create UI websites.',
    },
    {
        Id: '2',
        sIcon:swIcon2,
        title: 'Mobile UI/UX Design',
        slug: 'Mobile-UI-UX-Design',
        description:'We are helping client to create WordPress websites.',
        des2:'We are helping client to create WordPress websites.We are helping client to create UI websites.',
    },
    {
        Id: '3',
        sIcon:swIcon3,
        title: 'Branding Design',
        slug: 'Branding-Design',
        description:'We are helping client to create WordPress websites.',
        des2:'We are helping client to create WordPress websites.We are helping client to create UI websites.',
    },
    {
        Id: '4',
        sIcon:swIcon4,
        title: 'Creative Design',
        slug: 'Creative-Design',
        description:'We are helping client to create WordPress websites.',
        des2:'We are helping client to create WordPress websites.We are helping client to create UI websites.',
    },
    {
        Id: '5',
        sIcon:swIcon5,
        title: 'Movement',
        slug: 'Movement',
        description:'We are helping client to create WordPress websites.',
        des2:'We are helping client to create WordPress websites.We are helping client to create UI websites.',
    },
]    

export default Services;